import { en } from "./en";
import { de } from "./de";

export const dictionary = {
        ...en,
        ...de
};